/**
 * LensDirect-style "View Similar" on collection product cards (desktop).
 * Hover reveals button; click opens slide-in drawer with shape-matched products.
 */
(function () {
  const DESKTOP_MQ = '(min-width: 1061px)';
  const DRAWER_SELECTOR = '[data-ciw-similar-drawer]';
  const BODY_SELECTOR = '[data-similar-body]';
  const SECTION_ID = 'ciw-similar-styles';

  let drawerEl = null;
  let bodyEl = null;
  let isOpen = false;
  let activeFetch = null;

  function getDrawer() {
    if (drawerEl) return drawerEl;
    drawerEl = document.querySelector(DRAWER_SELECTOR);
    if (!drawerEl) return null;
    bodyEl = drawerEl.querySelector(BODY_SELECTOR);
    return drawerEl;
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.remove('slide-in');
      isOpen = true;
      document.documentElement.classList.add('ciw-similar-styles-open');
    });
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('slide-in');
    isOpen = false;
    document.documentElement.classList.remove('ciw-similar-styles-open');
    window.setTimeout(function () {
      if (!isOpen) drawer.hidden = true;
    }, 320);
  }

  function setBodyLoading() {
    if (!bodyEl) return;
    bodyEl.innerHTML = '<p class="ciw-similar-styles__loading">Loading similar styles…</p>';
  }

  function setBodyHtml(html) {
    if (!bodyEl) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section =
      doc.querySelector('[data-ciw-similar-section]') ||
      doc.getElementById('shopify-section-' + SECTION_ID) ||
      doc.querySelector('.ciw-similar-styles-section');
    bodyEl.innerHTML = section ? section.innerHTML : '<p class="ciw-similar-styles__empty">No similar styles found right now.</p>';
  }

  function loadSimilarProducts(handle) {
    if (!handle) return;
    if (activeFetch) activeFetch.abort();
    const controller = new AbortController();
    activeFetch = controller;

    setBodyLoading();
    openDrawer();

    const url = '/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;

    fetch(url, { signal: controller.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('Similar styles fetch failed');
        return res.text();
      })
      .then(function (html) {
        if (controller.signal.aborted) return;
        setBodyHtml(html);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (bodyEl) {
          bodyEl.innerHTML = '<p class="ciw-similar-styles__empty">Unable to load similar styles. Please try again.</p>';
        }
      })
      .finally(function () {
        if (activeFetch === controller) activeFetch = null;
      });
  }

  function onSimilarPointer(event) {
    const btn = event.target.closest('[data-ciw-view-similar]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
  }

  function onSimilarClick(event) {
    const btn = event.target.closest('[data-ciw-view-similar]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    loadSimilarProducts(btn.dataset.productHandle);
  }

  function onCloseClick(event) {
    if (event.target.closest('[data-similar-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && isOpen) closeDrawer();
  }

  function bindDrawer() {
    const drawer = getDrawer();
    if (!drawer || drawer.dataset.ciwSimilarBound === 'true') return;
    drawer.dataset.ciwSimilarBound = 'true';
    drawer.addEventListener('click', onCloseClick);
    document.addEventListener('keydown', onKeydown);
  }

  function init() {
    if (!window.matchMedia(DESKTOP_MQ).matches) return;
    bindDrawer();
    document.addEventListener('mousedown', onSimilarPointer, true);
    document.addEventListener('click', onSimilarClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    drawerEl = null;
    bodyEl = null;
    bindDrawer();
  });
})();
